module.exports = __webpack_public_path__ + "img/registered.35cde12c.png";